import noop from 'lodash/noop';

interface IHorizontalBarProps {
  className?: string;
  onClick?: () => void;
  stroke?: string;
  strokeWidth?: string;
  width?: number;
}

export const HorizontalBar = ({
  className,
  onClick = noop,
  stroke = '#818181',
  strokeWidth = '1.5',
  width = 25,
}: IHorizontalBarProps) => (
  <svg
    className={className}
    onClick={onClick}
    width={width}
    height="2"
    viewBox={`0 0 ${width} 2`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="0.75"
      y1="1.25"
      x2={width - 0.75}
      y2="1.25"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);
